import { render, staticRenderFns } from "./left-block.vue?vue&type=template&id=3e18d29e&scoped=true&"
import script from "./left-block.vue?vue&type=script&lang=js&"
export * from "./left-block.vue?vue&type=script&lang=js&"
import style0 from "./left-block.vue?vue&type=style&index=0&id=3e18d29e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e18d29e",
  null
  
)

export default component.exports